module.exports = __webpack_public_path__ + "img/journal-icon-disabled.f591a607.svg";